// Shared ProBound blend colours + surfacing → material spec mapping (used by the customer quote and the material calculator).
export const SURFACE_BLEND_GROUPS = [
  { group: 'Traditional', blends: ['Woodland***', 'Butterscotch***', 'Sahara***', 'Sand Dune', 'Maya Beach', 'Valencia***', 'Autumn Country***'] },
  { group: 'Classic', blends: ['Crimson Sands', 'Potala Palace', 'Amroth', 'Russo Azure', 'Galapagos', 'Caspian', 'St Moritz'] },
  { group: 'Modern', blends: ['Eclipse', 'Midnight Sapphire', 'Pebble Beach', 'Oceana', 'Empire', 'Antarctica'] },
  { group: 'Contemporary', blends: ['Arctic Blue', 'Howlite', 'Merlin', 'Liberty', 'Aventurine', 'Atlas'] },
];

// Customer-quote surfacing category → material calculator specification.
export const SURFACING_TO_SPEC = {
  vehicle_complete_probound: 'Vehicle traffic - surface and base',
  vehicle_complete_alt: 'Vehicle traffic - surface only',
  foot_traffic_probound: 'Foot traffic - surface and base',
  foot_traffic_alt: 'Foot traffic - surface only',
  overlays: 'Vehicle traffic - surface only',
};
